




















































































import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Cguidance extends Vue {
  // tab选中的栏
  activeName = "0";
  tabList0 = [
    {
      name: "5G通信技术工程师",
      list: {
        p0: "1、 熟悉5G基本概念、愿景及当前产业现状；",
        p1: "2、 熟悉5G无线网络的基本原理及网络能力；",
        p2: "3、 熟悉5G基站的基本功能；",
        p3: "4、 能够使用维护终端进行基本的5G基站操作；",
        p4: "5、 能够调测开通5G基站，并实现基本业务；",
        p5: "6、 能够使用测试工具进行基本的5G业务测试。"
      }
    },
    {
      name: "5G网规网优工程师",
      list: {
        p0: "1、 能够描述5G基本概念、愿景及当前产业现状；",
        p1: "2、 能够描述5G无线网络的基本原理及网络能力；",
        p2: "3、 能够描述5G基站的基本功能并执行基本操作；",
        p3: "4、 能够完成5G网络的简单规划和站点的初步设计；",
        p4: "5、 能够使用测试工具完成5G业务测试与网络数据收集；",
        p5: "6、 能够基于网管监控基本的5G无线网络性能指标进行规划设计。"
      }
    }
  ];
  // 运维类
  tabList1 = [
    {
      name: "5G业务编排工程师",
      list: {
        p0: "1、 能够描述5GC的基础概念，理解5GC基本信令流程； ",
        p1: "2、 熟悉5G SA核心网产品知识和基本特性；",
        p2:
          "3、 执行5G SA核心网产品的日常维护工作,包括安全管理、系统信息管理、告警管理、跟踪管理、数据管理、证书管理和性能管理；",
        p3: "4、 实践5G NFVI规划设计和垂直集成网络设计；",
        p4: "5、 实践VNFM部署及VNF生命周期管理；",
        p5: "6、 执行5G SA网络端到端网络参数规划设计；",
        p6: "7、 执行5G SA核心网端到端业务调测。"
      }
    },
    {
      name: "5G运维工程师",
      list: {
        p0: "1、 利用网管监控系统实时监控无线网络运行状态；",
        p1: "2、 判断监控警报的真实性；",
        p2: "3、 异常事件的协调处理与报告；",
        p3:
          "4、 负责服务器的配置,维护,监控,调优,故障排除；维护监控报警系统、自动构建工具等运维工具。"
      }
    }
  ];
  // 解决方案类
  tabList2 = [
    {
      name: "5G解决方案工程师",
      list: {
        p0: "1、 熟悉5G概念及5G发展驱动力，熟悉5G业务场景及能力需求；",
        p1: "2、 熟悉5G产业链及生态圈；",
        p2: "3、 掌握5G网络架构与关键技术；",
        p3:
          "4、 了解5G典型行业应用，了解5G典型行业应用场景了解5G典型应用的背景、需求及痛点；",
        p4: "5、 掌握5G典型行业应用端到端解决方案；",
        p5: "6、 了解行业应用典型案例。"
      }
    }
  ];
}
